import { Injectable } from '@angular/core';
import { OperationsService } from '../base/operations.service';
import { SaveOperation } from './save-operation';

@Injectable({
  providedIn: 'root',
})
export class SaveOperationsService extends OperationsService<SaveOperation> {
  addOperation(deleteAfterTimeout: number = null): SaveOperation {
    const operation = new SaveOperation(this._operations$, deleteAfterTimeout);
    this._operations$.next([...this._operations$.value, operation]);
    return operation;
  }
}
